import { createAction } from '@reduxjs/toolkit'
import { cloneDeep } from 'lodash'
import { ResponseStudioTemplates } from '@ads/front-core/api'
import { AppState } from '../../appState'

export const setStudioTemplateDraft = createAction<
  ResponseStudioTemplates[number]
>('draft/setStudioTemplateDraft')

export const setStudioTemplateDraftReducer = (
  state: AppState['draft'],
  action: ReturnType<typeof setStudioTemplateDraft>,
): void => {
  state.studioTemplate = cloneDeep(action.payload)
}
